// Le dictionnaire espagnol de l'interface (issue #137), dans son propre fichier
// pour ne pas alourdir `i18n.ts`.
//
// TRADUCTION AUTOMATIQUE, PAS ENCORE RELUE. La langue reste hors de
// `LANGUES_OUVERTES` (`lang.ts`) tant que quelqu'un qui la parle ne l'a pas
// relue : servie à qui la demande (`?lang=es`), jamais proposée.
//
// Typé `Record<CleUi, string>` : une clé ajoutée au français sans sa
// traduction ici fait échouer la compilation. Interface au tutoiement (« tú ») : la norme des
// interfaces en espagnol, quand le français et le néerlandais vouvoient.

import type { CleUi } from './i18n'

export const DICT_ES: Record<CleUi, string> = {
  'acces.fin.titre': 'Tu acceso a Radar ha terminado.',
  'acces.essai.fin': 'Tu prueba gratuita termina el {date}.',
  'acces.essai.choisir': 'Elegir un plan',
  'acces.fin.texte': 'Tus ofertas, tus candidaturas y tu CV siguen disponibles. La vigilancia nocturna y los nuevos CV adaptados se reanudarán con una suscripción.',
  'autreCompte.texte': 'Este enlace viene del correo de otra cuenta.',
  'autreCompte.changer': 'Cambiar de cuenta',
  'autreCompte.rester': 'Quedarme aquí',
  'abonnement.titre': 'Suscripción',
  'abonnement.sAbonner': 'Suscribirme',
  'abonnement.redirection': 'Redirigiendo al pago…',
  'abonnement.parMois': 'al mes',
  'abonnement.parAn': 'al año',
  'abonnement.ttc': 'IVA incluido',
  'abonnement.offert': 'Radar te sale gratis.',
  'compteurs.titre': 'Tu uso',
  'compteurs.cv': 'CV adaptados esta semana',
  'compteurs.employeurs': 'Empleadores seguidos',
  'compteurs.recherches': 'Salario y entrevista este mes',
  'compteurs.sur': 'de {max}',
  'compteurs.sansLimite': 'Sin límite',
  'compteurs.repart': 'Se reinicia el {date}',
  'compteurs.atteint': 'Alcanzado, se reinicia el {date}',
  'compteurs.plein': 'Límite alcanzado',
  'compteurs.avecComplet': 'Con Complet',
  'abonnement.essaiJusqua': 'Prueba gratuita hasta el {date}.',
  'abonnement.essaiFini': 'Tu prueba gratuita terminó el {date}.',
  'abonnement.duree': 'Duración',
  'abonnement.auMois': 'Mensual',
  'abonnement.alAnnee': 'Anual',
  'abonnement.radar': 'Radar',
  'abonnement.complet': 'Complet',
  'abonnement.radar.l1': '20 empleadores seguidos',
  'abonnement.radar.l2': '15 CV adaptados por semana',
  'abonnement.complet.l1': 'Todos los empleadores',
  'abonnement.complet.l2': 'CV adaptados sin límite',
  'abonnement.complet.l3': 'Salario y entrevista sin límite',
  'abonnement.radar.l3': 'Salario y entrevista: 2 al mes',
  'abonnement.radar.l4': '4 plantillas de CV',
  'abonnement.complet.l4': 'Mi diseño, sacado de tu CV',
  'abonnement.choisir': 'Elegir {plan}',
  'abonnement.abonne': 'Estás suscrito.',
  'abonnement.abonneJusqua': 'Estás suscrito. Próximo vencimiento: {date}.',
  'abonnement.finLe': 'Tu suscripción termina el {date}.',
  'abonnement.gerer': 'Tarjeta, facturas, cancelación',
  'abonnement.reprendre': 'Reanudar la suscripción',
  'abonnement.enRetard': 'El último pago ha fallado. Revisa tu tarjeta.',
  'abonnement.mettreAJour': 'Actualizar mi tarjeta',
  'abonnement.confirmation': 'Pago recibido, confirmación en curso…',
  'abonnement.confirmationLongue': 'La confirmación tarda. Stripe te la enviará por correo; recarga esta página dentro de unos minutos.',
  'abonnement.annule': 'Pago cancelado. No ha cambiado nada.',
  'abonnement.pasOuvert': 'El pago todavía no está abierto.',
  'nav.config': 'Configuración',
  'lang.toggle.label': 'Idioma de la interfaz',
  'nav.mainAria': 'Navegación principal',
  'nav.logout': 'Cerrar sesión',
  'nav.accountFallbackRadar': 'Mi cuenta',
  'nav.accountFallbackConsole': 'Business Manager',
  'nav.consultantsCount': '{n} consultores',
  'login.radar.accroche': 'Las ofertas hechas para ti, cada mañana.',
  'login.modes': 'Iniciar sesión o crear una cuenta',
  'login.ou': 'o',
  'login.mdp.voir': 'Mostrar la contraseña',
  'login.mdp.masquer': 'Ocultar la contraseña',
  'inscription.titre': 'Crear una cuenta',
  'inscription.mdp': 'Elige una contraseña',
  'inscription.mdpAide': 'Al menos {n} caracteres.',
  'inscription.envoyer': 'Crear mi cuenta',
  'inscription.envoi': 'Enviando…',
  'inscription.essai': 'Un mes gratis, sin tarjeta.',
  'inscription.robot': 'Marca la verificación antirrobots.',
  'inscription.parti.texte': 'Acabamos de enviar un enlace a {email}. Ábrelo para activar tu cuenta.',
  'inscription.autreAdresse': 'Usar otra dirección',
  'inscription.activation': 'Activando tu cuenta…',
  'inscription.lienInvalide': 'Este enlace ya no es válido. Vuelve a empezar el registro.',
  'login.subtitle.console': 'Consola de consultoría',
  'login.subtitle.admin': 'Administración',
  'login.subtitle.radar': 'Radar',
  'login.email': 'Correo electrónico',
  'login.password': 'Contraseña',
  'login.submitting': 'Iniciando sesión…',
  'login.submit': 'Iniciar sesión',
  'login.error.generic': 'No se pudo iniciar sesión.',
  'login.oubli.lien': '¿Has olvidado la contraseña?',
  'login.google.bouton': 'Continuar con Google',
  'login.google.sans_compte': 'No hay ninguna cuenta para esta dirección de Google. El acceso es por invitación.',
  'login.google.expire': 'El inicio de sesión con Google ha caducado. Inténtalo de nuevo.',
  'login.google.annule': 'Inicio de sesión con Google cancelado.',
  'login.google.erreur': 'Google no pudo confirmar tu identidad. Inténtalo de nuevo.',
  'login.google.ferme': 'Los registros están cerrados por ahora.',
  'login.google.inscription': '¿Todavía no tienes cuenta? Google la crea. Un mes gratis, sin tarjeta.',
  'login.google.refuse': 'No se puede crear una cuenta con esta dirección de Google.',
  'login.oubli.titre': 'Tu dirección',
  'login.oubli.envoyer': 'Recibir un enlace de acceso',
  'login.oubli.parti': 'Si existe una cuenta con esta dirección, acaba de salir un enlace. Es válido 30 minutos.',
  'accueil.step': 'Paso {n} de {total}',
  'accueil.next': 'Siguiente',
  'accueil.back': 'Anterior',
  'accueil.finish': 'Terminar',
  'accueil.done': 'Bienvenido. Todo está en “Primeros pasos” si quieres volver a leerlo.',
  'accueil.radar.title': 'Radar busca mientras haces otra cosa',
  'accueil.radar.lead': 'Sitios revisados cada noche, en tu lugar.',
  'accueil.radar.body': 'Eliges sitios de ofertas. Cada noche Radar los relee, se queda con lo nuevo, compara cada anuncio con tu CV y le da una puntuación. Por la mañana no buscas: clasificas lo que ha salido.',
  'accueil.radar.body2': 'Una oferta que te interesa se abre en una ficha: la puntuación detallada, lo que encaja, lo que falta, y todo para generar un CV adaptado y una carta.',
  'accueil.radar.shot1Alt': 'Pantalla “Mis oportunidades”: una lista de ofertas con su puntuación',
  'accueil.radar.shot2Alt': 'Ficha de una oferta: puntuación detallada, puntos fuertes y carencias',
  'accueil.extension.title': 'La extensión de Chrome trabaja donde estás',
  'accueil.extension.lead': 'En LinkedIn, en Indeed, en la web de un empleador: en todas partes.',
  'accueil.extension.body': 'Es opcional, pero es ella quien te acompaña en los anuncios: cuando miras uno, muestra tu puntuación, adapta tu CV a esa oferta y redacta una carta. Con un clic también la envía a Radar, para volver a ella más tarde.',
  'accueil.extension.videoNote': 'Dos minutos, y verás exactamente cómo es.',
  'accueil.ensemble.title': 'Dos herramientas independientes, mejores juntas',
  'accueil.ensemble.lead': 'Una busca por ti, la otra te acompaña cuando buscas tú.',
  'accueil.ensemble.passifTitle': 'Radar, el modo que funciona solo',
  'accueil.ensemble.passifBody': 'Relee tus sitios cada noche y te prepara una pila. No tienes que hacer nada para que trabaje.',
  'accueil.ensemble.actifTitle': 'La extensión, el modo del momento',
  'accueil.ensemble.actifBody': 'Actúa sobre el anuncio que tienes delante, incluso en un sitio que Radar no vigila.',
  'accueil.ensemble.body': 'Conectadas entre sí, aparece un botón en cada anuncio: un clic, y entra en Radar con su puntuación. La oferta que viste en LinkedIn a mediodía está en tu historial por la noche, y decidirás responder cuando tengas tiempo.',
  'accueil.ensemble.independants': 'Puedes usar solo una de las dos. Ninguna depende de la otra.',
  'accueil.cv.title': 'Tu CV, una vez',
  'accueil.cv.lead': 'Es la referencia con la que se compara todo.',
  'accueil.cv.body': 'Súbelo en PDF. Se lee y se estructura una sola vez, y luego sirve para puntuar cada oferta y producir los CV adaptados. Sin él no se puede comparar nada y tus pantallas se quedarán vacías.',
  'accueil.cv.cta': 'Subir mi CV',
  'accueil.cv.done': 'Tu CV ya está listo.',
  'accueil.metiers.title': 'Tus profesiones',
  'accueil.metiers.lead': 'Estas son las profesiones que hemos leído en tu CV.',
  'accueil.metiers.body': 'Radar solo evalúa para ti las ofertas de estas profesiones. Quita lo que no se parezca a ti, añade lo que falte: escribe una profesión y elige en la lista.',
  'accueil.metiers.enCours': 'Leyendo tu CV, unos segundos…',
  'accueil.metiers.needCv': 'Sube primero tu CV en el paso anterior.',
  'accueil.metiers.later': 'Podrás cambiarlas en cualquier momento en tu ficha de perfil.',
  'accueil.sites.title': 'Elige tus sitios',
  'accueil.sites.lead': 'No hay nada marcado: eres tú quien dice lo que quiere seguir.',
  'accueil.sites.body': 'Estos son los sitios que este Radar ya sabe leer. Marca los que te interesen: solo verás sus ofertas, y no molestas a nadie si cambias de opinión.',
  'accueil.sites.needCv': 'Sube tu CV en el paso anterior para poder elegir: los sitios se vinculan a tu perfil.',
  'accueil.sites.offers': '{n} ofertas',
  'accueil.sites.all': 'Marcar todo',
  'accueil.sites.none': 'Desmarcar todo',
  'accueil.sites.count': '{n} sitios elegidos',
  'accueil.sites.countMax': '{n} / {max} sitios elegidos',
  'accueil.sites.plafond': 'Como máximo {max} sitios: desmarca uno para elegir otro.',
  'accueil.sites.later': 'Podrás añadir, quitar o pedir sitios nuevos en cualquier momento en “Sitios seguidos”.',
  'accueil.revoir': 'Volver a ver la presentación',
  'aide.intro': 'Qué es Radar, cómo conectar la extensión, y lo que no funcionará a la primera. Esta página se queda aquí: vuelve cuando quieras.',
  'aide.what.title': 'Lo que Radar hace por ti',
  'aide.what.body': 'Radar vigila páginas de ofertas de empleo, cada noche, en tu lugar. Cada oferta encontrada se compara con tu CV y recibe una puntuación. Ya no buscas: miras lo que ha salido, y decides.',
  'aide.what.extension': 'La extensión de Chrome es la otra mitad: funciona en cualquier sitio de ofertas, muestra tu puntuación directamente en el anuncio, adapta tu CV y envía la oferta a Radar con un clic. Un anuncio visto en LinkedIn a mediodía aparece en Radar por la noche, con su puntuación, sin que hayas anotado nada.',
  'aide.step.cv.title': '1. Tu CV',
  'aide.step.cv.body': 'Todo parte de ahí: sin CV no se puede comparar nada. Súbelo en PDF, se lee y se estructura una vez. Podrás sustituirlo en cualquier momento.',
  'aide.step.cv.cta': 'Subir o actualizar mi CV',
  'aide.step.install.title': '2. Instalar la extensión',
  'aide.step.install.body': 'Gratis, en Chrome Web Store. Un clic, nada que configurar.',
  'aide.step.install.store': 'Añadir a Chrome',
  'aide.step.install.storeS1': 'En la ficha, haz clic en “Añadir a Chrome” y luego en “Añadir extensión”.',
  'aide.step.install.zipTitre': 'Instalar sin Chrome Web Store',
  'aide.step.install.zipQuand': 'Solo si la tienda está bloqueada para ti, por ejemplo en un ordenador de empresa.',
  'aide.step.link.autrement': '¿No ves el botón “Conectar con Radar”? Inicia sesión con tu dirección y tu contraseña de Radar, o con el código de abajo.',
  'accueil2.extension.texte': 'Tu puntuación en cada oferta, LinkedIn incluido: la extensión está en Chrome Web Store.',
  'accueil2.extension.plusTard': 'Más tarde',
  'aide.step.install.download': 'Descargar la extensión (versión {version})',
  'aide.step.install.unavailable': 'El paquete de la versión {version} todavía no está listo. Indícalo al final de esta página y recibirás un mensaje en cuanto esté disponible.',
  'aide.step.install.s1': 'Descomprime el archivo descargado en una carpeta que vayas a conservar: Chrome leerá la extensión desde ahí, la papelera la desinstalaría.',
  'aide.step.install.s2': 'Abre chrome://extensions en una pestaña nueva y activa “Modo de desarrollador” arriba a la derecha.',
  'aide.step.install.s3': 'Haz clic en “Cargar descomprimida” y elige la carpeta “ai-job-fit-{version}” que está DENTRO de la carpeta descomprimida, no la carpeta descomprimida en sí. Si Chrome responde “No se encuentra el manifiesto”, falta ese nivel.',
  'aide.step.install.s4': 'Fija el icono en la barra de herramientas: desde ahí activarás la extensión en los sitios que todavía no conoce.',
  'aide.step.install.sites': 'Se activa sola en LinkedIn, Indeed y las grandes herramientas de selección. En otros sitios Chrome pide tu permiso sitio por sitio: abre el anuncio, haz clic en el icono de la extensión y luego en “Activar en este sitio”. Es una regla de Chrome, no un límite de la herramienta.',
  'aide.step.link.title': '3. Conectar la extensión a Radar',
  'aide.step.link.body': 'Tu CV viene entonces de Radar: nada que importar en la extensión, y es aquí donde lo modificas.',
  'aide.step.link.lastUsed': 'Extensión conectada. Último envío: {date}.',
  'aide.step.link.neverUsed': 'Extensión conectada, pero todavía no ha llegado ninguna oferta a través de ella.',
  'aide.step.link.s1': 'Abre la extensión: la primera vez se abre sola. Si no, clic derecho en su icono y luego “Opciones”.',
  'aide.step.link.s2': 'Debajo de la importación del CV, haz clic en “¿Tienes una cuenta de Radar? Inicia sesión” y luego en “Conectar con Radar”. Chrome pide acceso a Radar: acéptalo.',
  'aide.step.link.s3': 'Tu CV aparece en la extensión, y en cada oferta aparece un botón “Guardar en Radar”.',
  'aide.step.sites.title': '4. Añadir un sitio que vigilar',
  'aide.step.sites.body': 'Pega la dirección de una página que LISTA ofertas, no de un solo anuncio. Radar prueba la extracción delante de ti y muestra los títulos encontrados antes de guardar nada.',
  'aide.step.sites.warning': 'Conviene saberlo de antemano: no funcionará a la primera en todos los sitios. Radar reconoce solo las grandes plataformas; cualquier otro sitio necesita una línea de configuración escrita a mano. En ese caso aparece un botón “solicitar la activación”: la solicitud se registra, recibes un correo de confirmación y luego otro cuando el sitio está en línea, normalmente en menos de una semana. No es una avería, es el funcionamiento normal.',
  'aide.step.sites.cta': 'Ir a mis sitios vigilados',
  'aide.shared.title': 'Lo que se comparte y lo que no',
  'aide.shared.body': 'Los sitios vigilados y las ofertas recogidas son COMUNES a las cuentas de este Radar: ves los sitios añadidos por los demás, y ellos ven los tuyos. Tu CV, tus puntuaciones, tus candidaturas y tus documentos solo los ves tú.',
  'aide.feedback.title': 'Unas palabras a quien desarrolla Radar',
  'aide.feedback.body': 'Algo no funciona, una pantalla es confusa, falta una función, un sitio no es compatible: escríbelo aquí. El mensaje llega directamente por correo, con tu dirección para que la respuesta te llegue.',
  'aide.feedback.typeLabel': 'De qué se trata',
  'aide.feedback.type.bug': 'Algo no funciona',
  'aide.feedback.type.idea': 'Una idea, una mejora',
  'aide.feedback.type.site': 'Un sitio que añadir',
  'aide.feedback.type.other': 'Otra cosa',
  'aide.feedback.messageLabel': 'Tu mensaje',
  'aide.feedback.placeholder': 'Lo que estabas haciendo, lo que esperabas, lo que pasó en su lugar.',
  'aide.feedback.send': 'Enviar',
  'aide.feedback.sending': 'Enviando…',
  'aide.feedback.sent': 'Mensaje enviado. Gracias, recibirás una respuesta en tu dirección.',
  'aide.feedback.stored': 'Mensaje guardado, pero el correo no ha salido. Se leerá igualmente.',
  'password.title': 'Elige tu contraseña',
  'password.intro': 'Esta cuenta se abrió con una contraseña provisional. Tienes que sustituirla antes de seguir.',
  'password.current': 'Contraseña provisional',
  'password.next': 'Nueva contraseña',
  'password.confirm': 'Confirmación',
  'password.rule': 'Al menos {n} caracteres. Ninguna otra regla: una frase que recuerdes vale más que una mezcla de símbolos.',
  'password.submit': 'Guardar y continuar',
  'password.submitting': 'Guardando…',
  'password.tooShort': 'La nueva contraseña debe tener al menos {n} caracteres.',
  'password.mismatch': 'Las dos entradas no coinciden.',
  'password.error.generic': 'No se pudo cambiar.',
  'password.error.same': 'La nueva contraseña debe ser distinta de la actual.',
  'password.logout': 'Cerrar sesión',
  'invite.title': 'Crea tu cuenta',
  'invite.intro': 'Este enlace abre una cuenta de {produit} con la dirección de abajo. Elige tu contraseña para empezar.',
  'invite.email': 'Dirección de la cuenta',
  'invite.submit': 'Crear mi cuenta',
  'invite.submitting': 'Creando…',
  'invite.loading': 'Comprobando el enlace…',
  'invite.gone.title': 'Este enlace ya no es válido',
  'invite.gone.expiree': 'Ha caducado. Pide un enlace nuevo a quien te lo envió.',
  'invite.gone.utilisee': 'Ya sirvió para crear una cuenta. Inicia sesión con la dirección y la contraseña que elegiste entonces.',
  'invite.gone.revoquee': 'Se ha sustituido o cancelado. Pide un enlace nuevo a quien te lo envió.',
  'invite.gone.inconnue': 'Este enlace está incompleto o es erróneo. Comprueba que se ha copiado entero.',
  'invite.gone.compte_existant': 'Ya existe una cuenta con esta dirección. Inicia sesión con su contraseña.',
  'invite.otherProduct': 'Este enlace abre una cuenta en otro sitio.',
  'invite.otherProductOpen': 'Abrir el sitio correcto',
  'invite.toLogin': 'Ir al inicio de sesión',
  'invite.error.generic': 'No se pudo crear la cuenta.',
  'candidature.stepToast': 'Etapa: {label}',
  'candidature.propose': 'Proponer',
  'candidature.proposeName': 'Proponer a {name}',
  'candidature.proposedToast': '{name} propuesto, la candidatura está en el seguimiento',
  'common.loading': 'Cargando…',
  'common.close': 'Cerrar',
  'common.cancel': 'Cancelar',
  'common.update': 'Actualizar',
  'common.import': 'Importar',
  'importCv.updateTitle': 'Actualizar a {name}',
  'importCv.importing': 'Importando…',
  'importCv.needFile': 'Elige un archivo PDF',
  'importCv.updatedToast': 'Perfil de {name} actualizado',
  'importCv.fileLabel': 'CV (PDF)',
  'importCv.depot': 'Arrastra aquí el PDF, o haz clic para elegirlo',
  'importCv.fileHelp': 'Extracción del texto, estructuración del perfil por la IA, luego vectorización para el matching (~10 s). El título del puesto se lee en el CV.',
  'importCv.nameLabel': 'Nombre (opcional)',
  'importCv.namePlaceholder': 'Si no: leído en el CV',
  'gapQuestions.title': 'Antes de generar, {n} detalles',
  'gapQuestions.titleOne': 'Antes de generar, un detalle',
  'gapQuestions.skip': 'Saltar',
  'gapQuestions.generating': 'Generando…',
  'gapQuestions.introPlural': 'La oferta pide cosas que el CV no dice explícitamente. Responder o no no cambia que el CV se adapte, solo lo que podrá destacar.',
  'gapQuestions.introSingular': 'La oferta pide algo que el CV no dice explícitamente. Responder o no no cambia que el CV se adapte, solo lo que podrá destacar.',
  'gapQuestions.placeholder': '¿Una experiencia que mencionar, aunque sea puntual? Si no, déjalo en blanco.',
  'gapQuestions.answeredNone': 'Nada rellenado por ahora, la adaptación saldrá sin enriquecimiento.',
  'gapQuestions.answeredPlural': 'Se tendrán en cuenta {n} respuestas.',
  'gapQuestions.answeredSingular': 'Se tendrá en cuenta 1 respuesta.',
  'gapQuestions.noneNeeded': 'Sin preguntas: el CV ya cubre la oferta.',
  'vivier.loading': 'Cargando la cantera…',
  'vivier.wentOnMission': '{name} en misión',
  'vivier.backOnBench': '{name} disponible de nuevo',
  'vivier.archivedToast': '{name} archivado, historial conservado',
  'vivier.reactivatedToast': '{name} reactivado',
  'vivier.summary': '{available} disponibles · {onMission} en misión · {archived} archivado(s)',
  'vivier.showActive': 'Ver la cantera activa',
  'vivier.showArchived': 'Archivados ({n})',
  'vivier.importCv': 'Importar un CV',
  'vivier.avgScore': 'Punt. media',
  'vivier.evaluated': 'Evaluado',
  'vivier.positioned': 'Propuesto',
  'vivier.updated': 'Act.',
  'vivier.reactivate': 'Reactivar',
  'vivier.onMission': 'En misión',
  'vivier.onBench': 'Disponible',
  'vivier.archive': 'Archivar',
  'vivier.dropzoneTitle': 'Importar un CV en PDF',
  'vivier.dropzoneHint': 'Extracción → perfil estructurado → vectorización. Evaluado en las próximas ofertas.',
  'vivier.noArchived': 'Ningún consultor archivado.',
  'dossier.revert': '↩ restaurar',
  'dossier.defautEnregistre': 'Ajustes guardados para tus próximos CV.',
  'modeles.sobre': 'Sobrio',
  'modeles.dates': 'Fechas a la izquierda',
  'modeles.colonnes': 'Dos columnas',
  'modeles.colonnes.note': 'Dos columnas: algunos programas de selección la leen mal.',
  'modeles.compact': 'Compacto',
  'modeles.perso': 'Mi diseño',
  'modeles.perso.complet': 'Con Completo',
  'modeles.perso.note': 'Sacado de tu CV. El Word mantiene el diseño estándar.',
  'modeles.perso.enCours': 'En preparación',
  'modeles.perso.aPreparer': 'Por preparar en Mi CV',
  'modeles.parDefaut': 'Esta plantilla servirá para tus próximos CV.',
  'config.modeleLabel': 'Diseño',
  'config.modele.sobreEffet': 'Una columna, que leen todos los programas de selección.',
  'config.modele.datesEffet': 'Las fechas en una columna, a la izquierda de cada puesto.',
  'config.modele.compactEffet': 'Más ajustado, para caber en menos páginas.',
  'config.modele.persoEffet': 'Sacado de tu CV, con Radar Completo.',
  'miseEnPage.titre': 'Mi diseño',
  'miseEnPage.texte': 'Tus CV adaptados pueden retomar el diseño de tu CV.',
  'miseEnPage.prete': 'Listo.',
  'miseEnPage.choix': 'La plantilla de tus próximos CV, la misma que en Ajustes.',
  'miseEnPage.enCours': 'En preparación…',
  'miseEnPage.echec': 'No se pudo sacar de tu CV.',
  'miseEnPage.preparer': 'Preparar mi diseño',
  'miseEnPage.refaire': 'Rehacer mi diseño',
  'miseEnPage.sansPdf': 'Sube tu CV en PDF para sacar su diseño.',
  'miseEnPage.complet': 'Con Radar Completo.',
  'miseEnPage.formules': 'Ver los planes',
  'miseEnPage.essai': 'Tu prueba incluye uno.',
  'dossier.revertedToast': 'Frase restaurada, auditoría recalculada',
  'dossier.loadingFile': 'Cargando el documento…',
  'dossier.notFound': 'Documento no encontrado',
  'dossier.regeneratingFile': 'Nueva versión en curso…',
  'dossier.generatedOn': 'Generado {date}',
  'dossier.ouvrirCv': 'Abrir el CV',
  'dossier.savedToast': 'CV guardado, auditoría recalculada',
  'categories.loadError': 'No se pudo cargar',
  'categories.title': 'Categorías',
  'categories.close': 'Cerrar',
  'categories.edit': 'Modificar',
  'categories.empty': 'Ninguna categoría. Mientras no haya ninguna, esta ficha no se vincula con ninguna oferta.',
  'categories.originHuman': 'corregida',
  'categories.originAi': 'propuesta',
  'categories.neighbours': 'Categorías vecinas',
  'categories.neighboursHelp': 'Los grupos hermanos de los de arriba. No activan una evaluación automática, pero dicen quién está justo al lado.',
  'categories.selectedEmpty': 'Todavía ninguna profesión. Escribe una abajo.',
  'categories.remove': 'Quitar',
  'categories.searchLabel': 'Añadir una profesión',
  'categories.searchPlaceholder': 'Escribe una profesión: desarrollador, enfermera, contable…',
  'categories.noResult': 'No se ha encontrado ninguna profesión. Prueba con otra palabra.',
  'categories.saving': 'Guardando…',
  'categories.save': 'Guardar',
  'categories.savedToast': 'Categorías guardadas',
  'suivi.loading': 'Cargando el seguimiento…',
  'suivi.activeCountPlural': '{n} candidaturas en curso',
  'suivi.activeCountSingular': '{n} candidatura en curso',
  'suivi.setAsideAt': 'aplazada {when}',
  'suivi.putBackTitle': 'Volver a poner en “{name}”',
  'suivi.putBackToast': '“{title}” vuelve a “{name}”',
  'suivi.closedSummary': '{placed} {placedLabel}, {refused} rechazada(s)',
  'suivi.offerGoneTitle': 'El anuncio ha desaparecido del sitio',
  'suivi.offerExpired': 'anuncio caducado',
  'suivi.noMovementTitle': 'Sin movimiento desde hace {n} días',
  'suivi.daysShort': '{n} d',
  'suivi.openFileTitle': 'Abrir: {name}',
  'suivi.noFileTitle': 'No se ha generado ningún CV adaptado para esta candidatura',
  'suivi.originalPosting': 'Anuncio original',
  'suivi.nextSend': 'Enviar la candidatura',
  'suivi.preuveTitre': 'Mis candidaturas enviadas',
  'suivi.preuveAide': 'Fecha, empleador y puesto, para el servicio de empleo.',
  'suivi.preuveCopier': 'Copiar la lista',
  'suivi.preuveCopiee': 'Lista copiada.',
  'suivi.preuveEchec': 'No se puede copiar desde este navegador.',
  'suivi.nextFollowUp': 'Hacer seguimiento el {date}',
  'suivi.nextFollowUpDue': 'Hacer seguimiento ahora (previsto el {date})',
  'suivi.nextInterview': 'Preparar la entrevista',
  'suivi.expiredTitle': 'Caducadas',
  'suivi.expiredHint': 'Ofertas retiradas del sitio antes del envío',
  'suivi.abandon': 'Abandonar',
  'suivi.abandonConfirm': '¿Abandonar esta candidatura?',
  'suivi.abandonCancel': 'Cancelar',
  'suivi.removeAriaTitle': 'Quitar “{title}” del seguimiento',
  'suivi.removeAriaName': 'Quitar a {name} del seguimiento',
  'suivi.removedToastTitle': '“{title}” quitada del seguimiento',
  'suivi.removedToastName': '{name} quitado del seguimiento',
  'veille.periodAll': 'Todas las fechas',
  'veille.periodToday': 'Hoy',
  'veille.period7d': 'Últimos 7 días',
  'veille.period30d': 'Últimos 30 días',
  'veille.loading': 'Cargando la vigilancia…',
  'veille.subtitle': 'Todo lo que han traído las fuentes · {n} ofertas seguidas',
  'veille.subtitleSingular': 'Todo lo que han traído las fuentes · {n} oferta seguida',
  'veille.searchPlaceholder': 'Buscar…',
  'veille.searchAria': 'Buscar',
  'veille.clearSearch': 'Borrar la búsqueda',
  'veille.manualEntryButton': 'Introducción manual',
  'veille.allCompanies': 'Todas las empresas',
  'veille.allLocations': 'Todos los lugares',
  'veille.allConsultants': 'Todos los consultores',
  'veille.periodAria': 'Periodo',
  'veille.statusAria': 'Estado',
  'veille.allStatuses': 'Todos los estados',
  'veille.shownPlural': '{n} ofertas mostradas',
  'veille.shownSingular': '{n} oferta mostrada',
  'veille.reset': 'Restablecer ({n})',
  'veille.colTitle': 'Oferta',
  'veille.colCompany': 'Empresa',
  'veille.colDetected': 'Detectada',
  'veille.colStatus': 'Estado',
  'veille.unread': 'No leída',
  'veille.missionBadge': 'Misión',
  'veille.viewOriginal': 'Ver el anuncio original',
  'veille.manualPlatform': 'introducción manual',
  'veille.noMatch': 'Ninguna oferta coincide con estos filtros.',
  'veille.resetFilters': 'Restablecer los filtros',
  'veille.evaluating': 'Evaluando…',
  'veille.addedToast': 'Oferta añadida, {n} perfil(es) evaluado(s)',
  'veille.addAndEvaluate': 'Añadir y evaluar',
  'veille.jobTitleLabel': 'Título del puesto',
  'veille.jobTitlePlaceholder': 'P. ej. Senior Backend Engineer, Java',
  'veille.companyLabel': 'Cliente / empresa',
  'veille.locationLabel': 'Ubicación',
  'veille.optional': 'Opcional',
  'veille.briefLabel': 'Pliego de condiciones',
  'veille.briefPlaceholder': 'Pega aquí la descripción completa…',
  'veille.briefHelp': 'Al menos 100 caracteres. La oferta se evalúa de inmediato.',
  'consultant.loading': 'Cargando la ficha…',
  'consultant.backToBench': 'Volver a la cantera',
  'consultant.updatedOn': 'actualizado el {date}',
  'consultant.printPdf': 'Imprimir / PDF',
  'consultant.noDocument': 'Ningún documento.',
  'consultant.originalPdf': 'PDF original',
  'consultant.cvEdit': 'Modificar',
  'consultant.cvSave': 'Guardar',
  'consultant.cvSaving': 'Guardando…',
  'consultant.cvCancel': 'Cancelar',
  'consultant.cvSaved': 'CV guardado',
  'consultant.cvDiscard': '¿Descartar los cambios sin guardar?',
  'consultant.keywordsTitle': 'Lo que se repite en tus ofertas',
  'consultant.keywordsIntroPlural': 'Sobre las {n} ofertas ya evaluadas para ti.',
  'consultant.keywordsIntroSingular': 'Sobre la {n} oferta ya evaluada para ti.',
  'consultant.keywordsCovered': 'Lo que tu CV ya cubre',
  'consultant.keywordsMissing': 'Lo que más faltaba',
  'consultant.filesTotal': '{n} en total',
  'consultant.offerArchived': 'oferta archivada',
  'consultant.fidelityTitle': 'Fidelidad al CV principal: {n} %',
  'consultant.noEvent': 'Todavía ningún evento.',
  'consultant.eventFidelity': ', fidelidad {n} %',
  'consultant.eventClient': ', {client}',
  'sources.addedToast': '{name} añadido, {n} ofertas insertadas',
  'sources.alreadyKnownToast': 'Radar ya vigilaba este sitio ({name}): ahora lo sigues',
  'sources.noneFollowed': 'Todavía no sigues ningún sitio. Pega arriba la dirección de una página de empleo, o explora los sitios que Radar ya vigila.',
  'sources.browseTitle': 'Explorar los {n} sitios que Radar ya vigila',
  'sources.browseHelp': 'Se vigilan para otras cuentas. Sigue los que te interesen: sus ofertas se compararán con tu CV.',
  'sources.browseSearch': 'Buscar un sitio o una empresa',
  'sources.browseNone': 'Ningún sitio coincide. Añádelo con su dirección, arriba.',
  'sources.loading': 'Cargando las fuentes…',
  'sources.title': 'Fuentes',
  'sources.activeSites': '{n} sitios activos',
  'sources.followedSites': '{n} sitios seguidos',
  'sources.followedSitesMax': '{n} / {max} sitios seguidos',
  'sources.errorCount': '{n} con error',
  'sources.watchedNightly': 'vigilado cada noche',
  'sources.addTitle': 'Añadir un sitio, pega la URL de su página de empleo',
  'sources.urlPlaceholder': 'https://empleo.ejemplo.es',
  'sources.urlAria': 'URL de la página de empleo',
  'sources.detect': 'Detectar',
  'sources.detecting': 'Reconociendo la plataforma y probando la extracción…',
  'sources.unreachablePrefix': 'Página',
  'sources.unreachable': 'inaccesible',
  'sources.unreachableSuffix': ', comprueba la URL.',
  'sources.unsupportedPrefix': 'Plataforma',
  'sources.unsupported': 'todavía no compatible',
  'sources.unsupportedSuffix': '. Compatibles hoy:',
  'sources.requestExplain': 'No es el final: solicita la activación abajo. Un sitio desconocido necesita una línea de configuración escrita a mano, lo único que no se puede adivinar. Recibirás un correo cuando esté en línea.',
  'sources.follow': 'Seguir',
  'sources.logoLabel': 'Logotipo',
  'sources.logoUrlPlaceholder': 'Dirección de una imagen (https://…)',
  'sources.logoSet': 'Usar',
  'sources.logoFile': 'Enviar un archivo',
  'sources.logoAuto': 'Recuperar el favicon del sitio',
  'sources.logoHelp': 'Un logotipo puesto a mano ya no lo sustituye nunca la búsqueda automática. PNG, SVG, ICO, JPEG o WebP, 512 KB como máximo.',
  'sources.logoUpdated': 'Logotipo actualizado.',
  'sources.unfollow': 'Dejar de seguir',
  'sources.followed': '{name}: sigues este sitio. Radar lee y evalúa sus ofertas, el progreso aparece arriba de la pantalla.',
  'sources.followedStale': '{name}: sigues este sitio. Nadie lo seguía, sus ofertas son de su última lectura ({date}): Radar lo relee ahora y luego evalúa sus ofertas.',
  'sources.notReadSince': 'Leído el {date}, se relee en cuanto lo sigas',
  'sources.neverRead': 'Se lee en cuanto lo sigas',
  'sources.staleState': 'Ofertas del {date}, relectura pendiente',
  'accueil.sites.staleHelp': 'Los sitios marcados como “no releído” se releerán en cuanto termines, antes de evaluar sus ofertas.',
  'offre.staleSource': 'Leída el {date}, no releída desde entonces: puede que ya esté cerrada',
  'offre.staleShort': 'no releída desde el {date}',
  'offre.republished': 'republicada (retirada el {date})',
  'offre.republishedMany': 'publicada {n} veces en 90 días',
  'offre.oldPosting': 'en línea desde hace {n} días',
  'taches.cv': 'Tu CV',
  'taches.phase.attente': 'en espera',
  'taches.phase.lecture': 'leyendo las ofertas',
  'taches.phase.classement': 'clasificando por profesión',
  'taches.phase.evaluation': 'evaluando las ofertas',
  'taches.phase.relecture': 'releyendo los sitios',
  'taches.unite.relecture': 'sitios releídos: {fait} de {total}',
  'taches.unite.lecture': 'páginas leídas: {fait} de {total}',
  'taches.unite.classement': 'ofertas clasificadas: {fait} de {total}',
  'taches.unite.evaluation': 'ofertas evaluadas: {fait} de {total}',
  'taches.fini': 'terminado, {n} oferta(s) evaluada(s)',
  'taches.finiEnAttente': 'terminado, {n} oferta(s) evaluada(s); {m} todavía no legible(s), evaluada(s) esta noche',
  'taches.erreur': 'interrumpido ({message}), la noche lo retomará',
  'sources.unfollowed': '{name}: ya no sigues este sitio. Sus ofertas desaparecen de tus pantallas, siguen ahí para los demás.',
  'sources.followedLabel': 'Seguido',
  'sources.notFollowedLabel': 'No seguido',
  'sources.request': 'Solicitar la activación',
  'sources.requesting': 'Enviando…',
  'sources.requestNotePlaceholder': 'Opcional: un detalle, por ejemplo la página que lista las ofertas',
  'sources.requestNoteAria': 'Detalle para la solicitud',
  'sources.requestSent': 'Solicitud registrada. Recibirás un correo de confirmación, y otro cuando el sitio esté en línea, normalmente en menos de {n} días.',
  'sources.requestSentNoMail': 'Solicitud registrada, pero el correo de confirmación no ha salido. Está en la lista de abajo.',
  'sources.requestFailed': 'No se pudo hacer la solicitud.',
  'sources.pendingTitle': 'Sitios pendientes de activación',
  'sources.pendingHelp': 'Solicitados, todavía no vigilados. Recibirás un correo en cuanto estén en línea.',
  'sources.pendingNoMail': 'ningún correo enviado para esta solicitud',
  'sources.recognizedPrefix': 'Plataforma reconocida:',
  'sources.viaHtml': '(leyendo la página)',
  'sources.offersFound': '{n} ofertas encontradas',
  'sources.preview': 'vista previa',
  'sources.actuallyWatched': 'Portal realmente vigilado:',
  'sources.adding': 'Añadiendo…',
  'sources.addToWatch': 'Añadir a la vigilancia',
  'sources.addAnyway': 'Añadir de todos modos',
  'sources.colCompany': 'Empresa',
  'sources.colPlatform': 'Plataforma',
  'sources.colHealth': 'Estado de salud',
  'sources.colLastCheck': 'Última comprobación',
  'sources.colOffers': 'Ofertas',
  'sources.errorLabel': 'Error, {detail}',
  'sources.paused': 'En pausa',
  'sources.active': 'Activo',
  'sources.reactivatedToast': 'Fuente reactivada',
  'sources.pausedToast': 'Fuente en pausa',
  'sources.resume': 'Reanudar',
  'sources.pause': 'Pausa',
  'sources.removeTitle': 'Quitar de la vigilancia',
  'sources.removedTitle': 'Quitadas de la vigilancia',
  'sources.removedAt': 'quitada {when}',
  'sources.wouldComeBack': '{n} ofertas volverían',
  'sources.restoredToast': '{name} vuelve a la vigilancia, {n} oferta(s) recuperada(s)',
  'sources.restoreToWatch': 'Volver a vigilar',
  'sources.removedToast': '{name} quitada, {n} oferta(s) archivada(s)',
  'sources.editTitle': 'Modificar {name}',
  'sources.detecting2': 'Detectando…',
  'sources.saving': 'Guardando…',
  'sources.updatedToast': 'Fuente actualizada',
  'sources.save': 'Guardar',
  'sources.companyLabel': 'Empresa',
  'sources.companyHelp': 'El nombre que se muestra en todas partes: en las ofertas, en el seguimiento y en el nombre de los CV exportados. Si se deja vacío, se usa el nombre de la fuente.',
  'sources.sourceNameLabel': 'Nombre de la fuente',
  'sources.sourceNameHelp': 'Para orientarte en esta lista, cuando una empresa tiene varios portales.',
  'sources.watchedUrlLabel': 'URL vigilada',
  'sources.urlWillRedetect': 'La plataforma se volverá a detectar en esta dirección. Si no se reconoce, no se guardará nada.',
  'sources.currentPlatform': 'Plataforma actual: {platform}.',
  'sources.removeConfirmTitle': '¿Quitar {name} de la vigilancia?',
  'sources.removing': 'Quitando…',
  'sources.removeFromWatch': 'Quitar de la vigilancia',
  'sources.removeConfirmP1': 'Ya no se consultará por la noche, y sus {n} ofertas salen de la vigilancia.',
  'sources.removeConfirmP2': 'No se borra nada: las puntuaciones calculadas, los expedientes generados y las candidaturas en curso siguen intactos, y la fuente vuelve a la vigilancia con un clic. Por eso se puede quitar sin preguntarse qué se pierde.',
  'decisions.loading': 'Cargando la pila…',
  'decisions.nothingPending': 'Nada pendiente',
  'decisions.countPlural': '{n} ofertas',
  'decisions.countSingular': '{n} oferta',
  'decisions.goodPlural': '{n} buenas coincidencias',
  'decisions.goodSingular': '{n} buena coincidencia',
  'decisions.lastRun': 'último proceso {when}',
  'decisions.searchAria': 'Buscar en la pila',
  'decisions.onboardTitle': 'Radar todavía no tiene nada que mostrarte',
  'decisions.onboardIntro': 'Es normal, tu cuenta se acaba de crear. Dos cosas que hacer, una vez, y la vigilancia funciona cada noche sin que tengas que pensar en ella.',
  'decisions.onboardStep1Title': 'Subir tu CV',
  'decisions.onboardStep1Help': 'Basta un PDF. Radar extrae tus experiencias y competencias, unos veinte segundos. Ese CV es la referencia de todas las comparaciones.',
  'decisions.onboardStep1Action': 'Subir un PDF',
  'decisions.onboardStep2Title': 'Elegir sitios que vigilar',
  'decisions.onboardStep2Help': 'Pega la dirección de una página de empleo. Radar reconoce la plataforma por sí solo y te muestra lo que consigue leer antes de que confirmes.',
  'decisions.onboardStep2Action': 'Añadir un sitio',
  'decisions.onboardNote': 'La primera noche de vigilancia empieza en cuanto añades el primer sitio. Puedes cerrar, Radar sigue.',
  'decisions.pileZeroText': 'Todo lo que ha llegado está decidido. Las propuestas en curso están en',
  'decisions.pileZeroTracking': 'el seguimiento',
  'decisions.pileZeroText2': 'y todo lo recogido sigue disponible en',
  'decisions.pileZeroWatch': 'la vigilancia',
  'decisions.tierAria': 'Nivel de coincidencia',
  'decisions.allScores': 'Todas las puntuaciones',
  'decisions.selectAll': 'Seleccionar todo',
  'decisions.selectedPlural': '{n} seleccionadas',
  'decisions.selectedSingular': '{n} seleccionada',
  'decisions.batchLater': 'aplazadas',
  'decisions.later': 'Más tarde',
  'decisions.batchSkipped': 'descartadas',
  'decisions.skip': 'Descartar',
  'decisions.deselect': 'Deseleccionar',
  'decisions.selectHint': 'Marca varias ofertas para descartarlas de una vez. Abrir una oferta no la saca de la pila.',
  'decisions.shownOfTotal': '{shown} de {total}',
  'decisions.noMatch': 'Ninguna oferta de la pila coincide con estos filtros.',
  'decisions.resetShort': 'Restablecer',
  'decisions.selectOffer': 'Seleccionar {title}',
  'decisions.laterTitle': 'La veré más tarde',
  'decisions.reopenedToast': '“{title}” recuperada, vuelve a estar por decidir',
  'decisions.skippedTitle': 'Descartadas',
  'decisions.skippedHint': 'No se elimina nada, puedes volver sobre la decisión',
  'decisions.skippedAt': 'descartada {when}',
  'decisions.reopenTitle': 'Volver a la pila',
  'decisions.reopen': 'Recuperar',
  'decisions.skippedToast': '“{title}” descartada',
  'decisions.laterToast': '“{title}” aplazada',
  'decisions.appliedToast': '“{title}” añadida a tus candidaturas',
  'decisions.sortButton': 'Clasificar ({n})',
  'decisions.thresholdLabel': 'Mostrarme a partir de',
  'decisions.thresholdEffect': '{n} de {total} ofertas por clasificar',
  'decisions.thresholdSaved': 'Umbral guardado: {n}',
  'tri.title': 'Clasificar mis oportunidades',
  'tri.progress': '{n} de {total}',
  'tri.close': 'Cerrar',
  'tri.doneTitle': 'Pila clasificada',
  'tri.doneText': '{n} ofertas clasificadas. Las que sigues están en tus candidaturas.',
  'tri.noProfile': 'Ninguna puntuación en esta oferta: abre la ficha para evaluarla.',
  'decisions.batchToast': '{n} oferta(s): {action}',
  'decisions.tierGood': 'Buena coincidencia',
  'decisions.tierGoodRange': '70 o más',
  'decisions.tierMid': 'Por verificar',
  'decisions.tierMidRange': 'de 40 a 69',
  'decisions.tierLow': 'Coincidencia débil',
  'decisions.tierLowRange': 'menos de 40',
  'offre.loading': 'Cargando la oferta…',
  'offre.notFound': 'Oferta no encontrada',
  'offre.statusAriaLabel': 'Decisión sobre esta oferta',
  'offre.kindMission': 'Misión',
  'offre.kindJob': 'Empleo',
  'offre.reperee': 'Detectada el {date}',
  'offre.avisEnFrancais': 'Esta opinión se redactó en francés.',
  'offre.avisEnAnglais': 'Esta opinión se redactó en inglés.',
  'offre.avisEnNeerlandais': 'Esta opinión se redactó en neerlandés.',
  'offre.avisEnItalien': 'Esta opinión se redactó en italiano.',
  'offre.avisEnEspagnol': 'Esta opinión se redactó en español.',
  'offre.avisRetraduit': 'Radar la reescribe en tu idioma en unas noches.',
  'offre.avisFaux': '¿Te parece errónea esta opinión?',
  'offre.avisFauxMerci': 'Gracias, tomamos nota.',
  'offre.avisPour': 'Para ti',
  'offre.avisAVerifier': 'Por verificar',
  'offre.avisAdapte': 'Con un CV adaptado: {n}',
  'offre.exigenceCouverte': 'Cubierto',
  'offre.exigenceAConfirmer': 'Por confirmar',
  'offre.exigenceManquante': 'Falta',
  'offre.detailScore': 'El detalle de la puntuación',
  'offre.annonceComplete': 'El anuncio completo',
  'offre.evaluatedProfilesPlural': '{n} perfiles evaluados',
  'offre.evaluatedProfilesSingular': '{n} perfil evaluado',
  'offre.originalPosting': 'Anuncio original',
  'offre.deadlineValue': 'Plazo: {value}',
  'offre.startValue': 'Inicio deseado: {value}',
  'offre.endValue': 'Fin previsto: {value}',
  'offre.notSetFem': 'sin indicar',
  'offre.notSetMasc': 'sin indicar',
  'offre.proposalsPlural': '{n} propuestas presentadas',
  'offre.proposalsSingular': '{n} propuesta presentada',
  'offre.proposalsUnset': 'número de propuestas sin indicar',
  'offre.frameworkUnset': 'acuerdo marco sin indicar',
  'offre.collapseDesc': 'Plegar la descripción',
  'offre.expandDesc': 'Leer la descripción completa',
  'offre.noDescriptionCaptured': 'No se ha recuperado ninguna descripción.',
  'offre.applicationsHeader': 'Candidaturas',
  'offre.proposedAgo': 'propuesto {when}',
  'offre.viewFileLink': 'ver el expediente',
  'offre.candidats': 'Candidatos',
  'offre.aucunCandidat': 'Todavía ningún perfil evaluado.',
  'offre.compareName': 'Comparar a {name}',
  'offre.scoreAriaLabel': '{name}: {score} sobre 100',
  'offre.onDemandTitle': 'Evaluado a petición tuya, fuera de la preselección',
  'offre.gainAfterAdaptation': '↑ {gain} tras la adaptación',
  'offre.fileGeneratedTitle': 'Expediente generado',
  'offre.compareHintBase': 'Marca dos o más perfiles para compararlos lado a lado,',
  'offre.compareOr': 'o',
  'offre.compareBest': 'compara los {n} mejores',
  'offre.compareFreeSuffix': ' ya es gratis e inmediato, todo está en la base.',
  'offre.compareMax': 'Como máximo {n} perfiles en una comparación',
  'offre.journal': 'Registro de la oferta',
  'offre.generatingFile': 'Generando el expediente de {name}…',
  'offre.generatingHelp': 'Reescritura fiel del CV para la oferta. Cada cambio se auditará.',
  'offre.comparedCount': '{n} perfiles comparados en esta oferta',
  'offre.closeComparison': 'Cerrar la comparación',
  'offre.generateTheirFile': 'Generar su expediente',
  'offre.applyTitle': '¿Te postulas?',
  'offre.applyBody1': 'la añade a tus candidaturas, sin calcular nada.',
  'offre.adaptCvLabel': 'Adaptar mi CV',
  'quota.restantes': 'Te quedan {n} de {max} adaptaciones esta semana',
  'quota.aZero': 'No te quedan adaptaciones esta semana. El contador se reinicia el lunes.',
  'offre.applyBody2': 'lo reescribe para esta oferta: es el único paso que cuesta algo, y solo ocurre si lo pides.',
  'offre.presentTitle': '¿Listo para presentar a {name}?',
  'offre.presentBody1': 'crea la candidatura y la sigue, sin llamar a nada.',
  'offre.theFileLabel': 'El expediente',
  'offre.presentBody2': '(CV reescrito para la oferta + auditoría) es el único paso costoso, y solo se genera si lo pides.',
  'offre.alreadyInApplications': 'ya está en tus candidaturas',
  'offre.alreadyProposed': 'ya propuesto',
  'offre.about15s': '~15 s',
  'offre.generateAdaptedFile': 'Generar el expediente adaptado',
  'offre.emptyAnalysis': 'Todavía ninguna evaluación.',
  'offre.statusSkippedToast': 'Oferta descartada',
  'offre.statusLaterToast': 'Apartada, está en el seguimiento',
  'offre.statusReopenedToast': 'De vuelta en las decisiones pendientes',
  'offre.neighboursTitle': 'Perfiles de categorías vecinas',
  'offre.neighboursHelp': 'No comparten la categoría de esta oferta, sino una categoría hermana. No se evalúan automáticamente.',
  'offre.scoredToast': '{name}: {score}/100',
  'offre.evaluate': 'Evaluar',
  'offre.notYetEvaluated': 'Esta oferta todavía no se ha evaluado para ti',
  'offre.evaluatingLabel': 'Evaluando…',
  'offre.alreadyScoredToast': 'Ya evaluada: {score}/100',
  'offre.evaluatedToast': 'Evaluada: {score}/100',
  'offre.evaluateMyProfile': 'Evaluar mi perfil',
  'offre.evaluateHelp': '~3 s, una llamada a la IA. El resultado se conserva.',
  'offre.evaluateAnother': 'Evaluar otro perfil',
  'offre.employerUnknown': 'Empleador sin indicar',
  'offre.employerViaSource': 'vía {source}',
  'offre.radarSkipToast': 'No es para mí: no volverá',
  'offre.radarLaterToast': 'Guardada en Mis ofertas. Radar te la recordará el lunes {date} si sigue en línea.',
  'offre.radarReopenToast': 'Decisión anulada',
  'decisions.skippedToastRadar': '“{title}”: no es para mí',
  'decisions.reopenedToastRadar': '“{title}” vuelve a estar en tus oportunidades',
  'sources.colState': 'Estado',
  'sources.stateOk': 'OK',
  'sources.broken': 'Averiado',
  'sources.brokenSince': 'Averiado desde el {date}',
  'veille.notScored': 'Sin evaluar',
  'offre.appliedToast': 'Añadida a tus candidaturas',
  'offre.descriptionTitle': 'El puesto',
  'offre.behindTheScenes': 'Cómo ha tratado Radar esta oferta',
  'offre.generatingMyCv': 'Adaptando tu CV…',
  'config.loading': 'Cargando los ajustes…',
  'config.saving': 'Guardando…',
  'config.savedToast': 'Ajustes guardados',
  'config.save': 'Guardar',
  'config.sliderAria': 'Puntuación mínima para entrar en la pila',
  'config.scaleLow': '← verlo todo, incluso lo que no encaja',
  'config.scaleHigh': 'ver solo las mejores coincidencias →',
  'config.computingEffect': 'Calculando el efecto…',
  'config.thresholdReference': 'Referencia: el motor juzga “no” por debajo de 40, “quizá” hasta 68, “sí” a partir de 70.',
  'config.optimizationLabel': 'Nivel de adaptación',
  'config.optimizationBalanced': 'Equilibrado',
  'config.optimizationTargeted': 'Dirigido',
  'config.toneLabel': 'Tono',
  'config.toneSober': 'Sobrio',
  'config.toneDynamic': 'Dinámico',
  'config.toneExecutive': 'Ejecutivo',
  'config.lengthLabel': 'Longitud',
  'config.languageLabel': 'Idioma',
  'config.langue.auto': 'El de la oferta',
  'config.langue.autoEffet': 'El idioma de la oferta si tu CV dice que lo hablas, si no el inglés.',
  'config.langue.fr': 'Francés',
  'config.langue.frEffet': 'Siempre en francés.',
  'config.langue.en': 'Inglés',
  'config.langue.enEffet': 'Siempre en inglés.',
  'config.length1Page': '1 página',
  'config.length2Pages': '2 páginas',
  'config.lengthUnlimited': 'Sin límite',
  'config.questionsLabel': 'Preguntas antes de generar',
  'config.questionsOnce': 'Una vez por oferta',
  'config.questionsAlways': 'En cada generación',
  'config.niveau.fidele': 'Fiel',
  'config.niveau.audacieux': 'Audaz',
  'config.niveau.fideleEffet': 'Conserva todas tus líneas, las reescribe y las reordena para la oferta.',
  'config.niveau.equilibreEffet': 'Reescribe libremente y acorta un poco lo que menos sirve a la oferta.',
  'config.niveau.cibleEffet': 'Conserva lo que sirve a la oferta, acorta el resto.',
  'config.niveau.audacieuxEffet': 'Puede afirmar lo que pide la oferta y tu CV no dice.',
  'config.ton.sobreEffet': 'Frases directas, sin superlativos.',
  'config.ton.dynamiqueEffet': 'Verbos de acción, resultados por delante.',
  'config.ton.executifEffet': 'Dirección, visión, responsabilidades.',
  'config.longueur.unePageEffet': 'Solo lo esencial para esta oferta.',
  'config.longueur.deuxPagesEffet': 'Conciso, sin sacrificarlo todo.',
  'config.longueur.sansLimiteEffet': 'Sin restricción de longitud.',
  'config.questions.aide': 'Sobre lo que pide la oferta y tu CV no dice, y luego sobre el enfoque de la carta.',
  'config.questions.uneFoisEffet': 'Se hacen en la primera generación para una oferta, y ya no más.',
  'config.questions.toujoursEffet': 'Se vuelven a hacer antes de cada CV y cada carta.',
  'compte.motDePasse': 'Contraseña',
  'compte.changer': 'Cambiar',
  'compte.telecharger': 'Descargar mis datos',
  'compte.supprimer': 'Eliminar mi cuenta',
  'compte.supprimerAide': 'Tu CV, tus candidaturas, tus CV adaptados y tus ajustes se borran. Las facturas se quedan en Stripe. Es definitivo.',
  'compte.supprimerConfirmer': 'Eliminar definitivamente',
  'compte.actuel': 'Contraseña actual',
  'compte.motDePasseAide': 'Al menos {n} caracteres. Tus otros dispositivos se desconectarán.',
  'compte.enregistrer': 'Cambiar la contraseña',
  'compte.actuelFaux': 'La contraseña actual no es correcta.',
  'config.signature': 'Firma',
  'config.authorLabel': 'Tu nombre',
  'radar.moi': 'Yo',
  'radar.menuAria': 'Mi cuenta',
  'reglages.titre': 'Ajustes',
  'mails.quand': 'Cuándo',
  'marche.offres1': '1 oferta como la tuya este mes',
  'marche.offres': '{n} ofertas como la tuya este mes',
  'marche.chez1': 'en 1 empleador',
  'marche.chez': 'en {e} empleadores',
  'marche.salaire': 'Salario indicado: de {min} a {max} €.',
  'sugg.employeur': '{n} rechazos “No este empleador” para {nom}.',
  'sugg.employeurAction': 'Silenciar {nom}',
  'sugg.regions': '{n} rechazos “Demasiado lejos”.',
  'sugg.regionsAction': 'Elegir tus regiones',
  'sugg.salaire': '{n} rechazos por el salario.',
  'sugg.salaireAction': 'Fijar un mínimo',
  'sugg.metier': '{n} rechazos “No es mi profesión”.',
  'sugg.metierAction': 'Revisar tus profesiones',
  'sugg.seuil': 'Desde hace una semana nada ha superado tu umbral. Tus mejores ofertas están en {n}.',
  'sugg.seuilAction': 'Pasar a {seuil}',
  'sugg.seuilFait': 'Umbral fijado en {seuil}.',
  'cherche.placeholder': 'Buscar en todas las ofertas seguidas',
  'cherche.rien': 'Ninguna oferta.',
  'tri.ouvrir': 'Clasificación rápida',
  'tri.titre': 'Clasificación rápida · {n} / {total}',
  'tri.voir': 'Ver',
  'tri.plusTard': 'Más tarde',
  'tri.pasPourMoi': 'No es para mí',
  'tri.passer': 'Siguiente sin decidir',
  'tri.fermer': 'Cerrar',
  'tri.fini': 'Todo clasificado.',
  'tri.plusTardOk': 'Guardada para más tarde.',
  'tri.pasPourMoiOk': 'Descartada.',
  'excl.cdd': 'Temporal',
  'excl.interim': 'ETT',
  'excl.freelance': 'Autónomo',
  'excl.stage': 'Prácticas',
  'excl.junior': 'Junior',
  'excl.senior': 'Senior',
  'excl.langues': 'Idiomas exigidos que no hablo',
  'excl.salaire': 'Salario bruto anual mínimo',
  'excl.contrats': 'Contratos aceptados',
  'excl.cdi': 'Indefinido',
  'excl.confirme': 'Con experiencia',
  'excl.niveaux': 'Niveles que me convienen',
  'excl.teletravail': 'Teletrabajo',
  'excl.temps': 'Jornada',
  'excl.tempsPlein': 'Jornada completa',
  'excl.tempsPartiel': 'Media jornada o 4/5',
  'excl.peuImporte': 'Me da igual',
  'excl.hybride': 'Al menos híbrido',
  'excl.salaireAucun': 'Ninguno',
  'excl.salaireAutre': 'Otro…',
  'excl.k': '{n} k€',
  'excl.parAn': '€ brutos al año',
  'excl.jeParle': 'Hablo',
  'excl.parle.fr': 'Francés',
  'excl.parle.nl': 'Neerlandés',
  'excl.parle.en': 'Inglés',
  'excl.parle.de': 'Alemán',
  'reglages.cherche.titre': 'Lo que busco',
  'reglages.cherche.aide': 'Vale para los correos y la página de inicio. Una oferta que no dice nada sobre un punto pasa siempre.',
  'reglages.regions': 'Dónde',
  'reglages.ecrit.titre': 'Cuándo me escribe Radar',
  'reglages.avance': 'Avanzado',
  'reglages.compte.titre': 'Mi cuenta',
  'reglages.mails.coupesIci': 'Los correos están desactivados. Se reactivan en “Mi cuenta”.',
  'mails.matin': 'La misma mañana',
  'mails.hebdo': 'Solo los lunes',
  'mails.quels': 'Qué correos',
  'mails.mots': 'Palabras seguidas',
  'mails.motsAide': 'Una oferta nueva que contenga una de ellas te llega por correo, sea cual sea su puntuación. Diez como máximo, separadas por comas.',
  'mails.motsExemple': 'Kubernetes, product owner',
  'mails.lundi': 'Resumen del lunes',
  'mails.relance': 'Seguimiento a los 7 días',
  'mails.accueil': 'Umbral de la página de inicio',
  'mails.commeMails': 'Como los correos ({n})',
  'mails.saved': 'Guardado.',
  'mails.prioritaire': 'Prioritario',
  'mails.muet': 'Silenciado',
  'mails.prioritaireAide': 'Toda oferta en tus profesiones te llega por correo.',
  'mails.muetAide': 'Ningún correo más para este empleador.',
  'reglages.mails.coupes': 'Ya no recibes los correos de Radar. Sigue vigilando: tus ofertas siguen aquí.',
  'reglages.mails.reactiver': 'Volver a recibir los correos',
  'reglages.mails.couper': 'Dejar de recibir correos',
  'rythme.aria': 'Ritmo de los correos',
  'rythme.discret.nom': 'Discreto',
  'rythme.discret.seuil': '80 o más',
  'rythme.discret.desc': 'Solo las ofertas muy cercanas a tu CV.',
  'rythme.equilibre.nom': 'Equilibrado',
  'rythme.equilibre.seuil': '70 o más',
  'rythme.equilibre.desc': 'Las ofertas cercanas a tu CV.',
  'rythme.actif.nom': 'Busco activamente',
  'rythme.actif.seuil': '60 o más',
  'rythme.actif.desc': 'También las ofertas algo más alejadas.',
  'rythme.estimationZero': 'Ninguna oferta en los últimos 30 días',
  'rythme.estimationUn': '1 oferta en los últimos 30 días',
  'rythme.estimationPlus': '{n} ofertas en los últimos 30 días',
  'rythme.note': 'Contadas sobre tus empleadores en los últimos 30 días. Una noche, un correo como máximo.',
  'rythme.perso': 'Tu umbral actual, {n}, se fijó a mano. Elegir un ritmo lo sustituye.',
  'accueil2.sansCv': 'Radar compara cada oferta con tu CV. Sin él, no tiene nada que mostrarte.',
  'accueil2.sansCvAction': 'Subir mi CV',
  'accueil2.titreNouvelleUn': 'Una oferta nueva supera tu umbral de {seuil}.',
  'accueil2.titreNouvellesPlus': '{n} ofertas nuevas superan tu umbral de {seuil}.',
  'accueil2.titreAttenteUn': 'Te espera una oferta por encima de {seuil}.',
  'accueil2.titreAttentePlus': 'Te esperan {n} ofertas por encima de {seuil}.',
  'accueil2.titreCalme': 'Nada nuevo por encima de {seuil}.',
  'accueil2.aucunSuivi': 'Todavía no sigues a ningún empleador.',
  'accueil2.aFaire': 'Por hacer',
  'accueil2.finFile': 'Eso es todo por hoy.',
  'file.aria': 'Ofertas por clasificar',
  'file.position': 'Oferta {rang} de {total}',
  'file.suivante': 'Siguiente',
  'file.terminer': 'Terminar',
  'accueil2.etat': 'Radar ha releído tus sitios {quand}.',
  'accueil2.etatPremiere': 'Primera lectura de tus sitios esta noche.',
  'accueil2.lundi': 'Resumen el lunes, aunque no haya novedades.',
  'accueil2.mailsCoupes': 'No recibes correos.',
  'accueil2.mailsReactiver': 'Reactivarlos',
  'accueil2.pause': 'Correos en pausa hasta el {date}',
  'accueil2.reprendre': 'Reanudar ahora',
  'pause.titre': 'Hacer una pausa',
  'pause.uneSemaine': '1 semana',
  'pause.semaines': '{n} semanas',
  'pause.jusqua': 'En pausa hasta el {date}',
  'accueil2.pourVous': 'Para ti',
  'accueil2.pourVousPlus': 'Las {n} mejores de {total}.',
  'accueil2.nouvelle': 'Nueva',
  'accueil2.via': 'vía {site}',
  'accueil2.atoutsLabel': 'Para ti:',
  'accueil2.manquesLabel': 'Por verificar:',
  'accueil2.tranchee': '{etat}: {titre}',
  'accueil2.dessousTitre': 'Justo por debajo',
  'accueil2.plusProches': 'Las más cercanas',
  'accueil2.dessousUn': '1 oferta entre {min} y {max} esta semana',
  'accueil2.dessousPlus': '{n} ofertas entre {min} y {max} esta semana',
  'accueil2.dessousNote': 'No se te han enviado por correo.',
  'accueil2.changerRythme': 'Cambiar mi ritmo',
  'accueil2.choisirEmployeurs': 'Elegir mis empleadores',
  'accueil2.empErreur': 'Ilegible en este momento. El equipo está avisado, no tienes que hacer nada.',
  'accueil2.empAnnonces': 'Sitio de anuncios: {n} ofertas en tus profesiones, la mejor en {m}',
  'accueil2.empAnnoncesRien': 'Sitio de anuncios: nada en tus profesiones por ahora',
  'accueil2.empAnnoncesUn': 'Sitio de anuncios: 1 oferta en tus profesiones, en {m}',
  'accueil2.empRecrutePlus': 'Contrata en tus profesiones: {n} ofertas, la mejor en {m}',
  'accueil2.empRecruteUn': 'Contrata en tus profesiones: 1 oferta, en {m}',
  'accueil2.empCalme': 'Tranquilo en tus profesiones.',
  'accueil2.enCoursUn': '1 candidatura en curso',
  'accueil2.enCoursPlus': '{n} candidaturas en curso',
  'bienvenue.etape': 'Paso {n} de 3',
  'bienvenue.cv.titre': 'Primero, tu CV',
  'bienvenue.cv.sous': 'Radar lo lee una vez y luego lo usa para comparar cada oferta. Sigue siendo privado.',
  'bienvenue.essai': 'Radar es gratis durante un mes, sin tarjeta.',
  'bienvenue.cv.extension': 'Tu extensión ya tiene tu CV.',
  'bienvenue.cv.reprendre': 'Usarlo',
  'bienvenue.cv.reprendreEchec': 'No se pudo leer el CV de la extensión.',
  'ext.installee': 'Tu extensión está instalada.',
  'ext.connecter': 'Conectarla',
  'ext.connectee': 'Extensión conectada.',
  'ext.echec': 'La conexión no se completó. Inténtalo de nuevo.',
  'ext.echecSansCv': 'Sube primero tu CV a Radar.',
  'bienvenue.cv.depot': 'Arrastra aquí tu CV en PDF',
  'bienvenue.cv.ou': 'o toca para elegir un archivo',
  'bienvenue.cv.lecture': 'Radar lee tu CV, unos veinte segundos…',
  'bienvenue.cv.lu': 'Tu CV está leído.',
  'bienvenue.cv.luNom': 'Tu CV está leído: {nom}.',
  'bienvenue.cv.metiers': 'Radar buscará puestos de',
  'bienvenue.cv.metiersAide': 'Quita lo que no te interese, añade lo que falte. Radar solo evalúa las ofertas de estas profesiones.',
  'bienvenue.cv.suivant': 'Ese soy yo',
  'bienvenue.emp.titre': '¿A quién le dirías que sí mañana?',
  'bienvenue.emp.sous': 'Elige hasta {max} sitios. Radar relee sus ofertas cada noche. Están ordenados según tus profesiones.',
  'bienvenue.emp.sousSansMax': 'Radar relee sus ofertas cada noche. Están ordenados según tus profesiones.',
  'bienvenue.emp.dansMetiers': '{n} en tus profesiones',
  'bienvenue.emp.rien': 'Hoy nada en tus profesiones',
  'bienvenue.emp.annoncesTitre': 'Sitios de anuncios',
  'bienvenue.emp.annoncesAide': 'Publican para cientos de empleadores, y Radar solo se queda con tus profesiones. Marcados de entrada: de ellos viene la mayoría de las buenas ofertas.',
  'bienvenue.emp.employeursTitre': 'Empleadores',
  'bienvenue.emp.manque': '¿No está tu empleador? Añade la dirección de su página de empleo desde la pestaña Empleadores, cuando tu radar esté listo.',
  'bienvenue.continuer': 'Continuar',
  'bienvenue.retour': 'Volver',
  'bienvenue.rythme.titre': '¿Cuándo quieres que te molestemos?',
  'bienvenue.rythme.pasEncore': 'Radar está comparando ahora las ofertas de tus sitios con tu CV. A partir de mañana verás en tus ajustes cuántas envía cada ritmo.',
  'bienvenue.fin': 'Activar mi radar',
  'offre.vpQuestion': '¿Te postulas?',
  'offre.vpOui': 'Sí, preparar mi CV',
  'offre.vpCvPret': 'Tu CV está listo.',
  'offre.vpSansAdapter': 'Me postulo sin adaptar mi CV',
  'suivi.aDecider': 'Tus ofertas guardadas',
  'suivi.aDeciderAide': 'Guardadas desde la extensión o añadidas a mano.',
  'suivi.gardeeLe': 'Guardada el {date}',
  'regions.question': '¿Dónde aceptas trabajar?',
  'regions.aide': 'Nada marcado: en cualquier sitio. Una oferta en otro lugar nunca se envía por correo, pero sigue visible en su empleador. Una oferta sin lugar conocido pasa siempre.',
  'regions.aria': 'Regiones',
  'regions.bruxelles': 'Bruselas',
  'regions.wallonie': 'Valonia',
  'regions.flandre': 'Flandes',
  'regions.luxembourg': 'Luxemburgo',
  'regions.etranger': 'Fuera de Bélgica y Luxemburgo',
  'filtre.titre': '¿Qué seguir en {nom}?',
  'filtre.aide': '{n} ofertas en línea. Marca al menos una zona o un idioma.',
  'filtre.aidePetit': '{n} ofertas en línea. Nada marcado: todo.',
  'filtre.aideTraduite': '{n} ofertas, publicadas cada una en varios idiomas. Elige uno.',
  'filtre.lecture': 'Radar lee {n} ofertas por noche, las más recientes primero.',
  'emp.enLecture': 'Leyendo: las más recientes primero.',
  'filtre.zones': 'Dónde',
  'filtre.langues': 'Idioma del anuncio',
  'filtre.suivre': 'Seguir',
  'filtre.enregistrer': 'Guardar',
  'filtre.enregistre': 'Filtro guardado.',
  'filtre.changer': 'Cambiar el filtro',
  'filtre.vide': 'Ninguna zona ni idioma legible en este sitio.',
  'zones.brabant-wallon': 'Brabante Valón',
  'zones.hainaut': 'Henao',
  'zones.liege': 'Lieja',
  'zones.luxembourg-be': 'Provincia de Luxemburgo',
  'zones.namur': 'Namur',
  'zones.anvers': 'Amberes',
  'zones.brabant-flamand': 'Brabante Flamenco',
  'zones.flandre-occidentale': 'Flandes Occidental',
  'zones.flandre-orientale': 'Flandes Oriental',
  'zones.limbourg': 'Limburgo',
  'zones.france': 'Francia',
  'zones.pays-bas': 'Países Bajos',
  'zones.allemagne': 'Alemania',
  'zones.suisse': 'Suiza',
  'zones.autre-pays': 'Otros países',
  'langues.fr': 'Francés',
  'langues.nl': 'Neerlandés',
  'langues.en': 'Inglés',
  'langues.de': 'Alemán',
  'accueil2.horsRegionsUn': '1 oferta más por encima de {seuil} está fuera de tus regiones.',
  'accueil2.horsRegionsPlus': '{n} ofertas más por encima de {seuil} están fuera de tus regiones.',
  'accueil2.exclueUn': '1 oferta descartada por tus criterios.',
  'accueil2.excluesPlus': '{n} ofertas descartadas por tus criterios.',
  'accueil2.changerCriteres': 'Tus criterios',
  'accueil2.changerRegions': 'Cambiar mis regiones',
  'emp.calmeDepuis': 'Tranquilo en tus profesiones. Última oferta hace {n} semanas.',
  'raison.question': '¿Por qué? (opcional)',
  'aide.code.bouton': 'Mostrar un código de acceso',
  'aide.code.aide': 'En la extensión, Opciones, “Iniciar sesión con un código de Radar”: escribe este código. Sin contraseña que volver a teclear. Válido 10 minutos, una sola vez.',
  'aide.code.aria': 'Código de acceso de la extensión',
  'aide.pont.ok': 'Extensión conectada. Puedes cerrar esta pestaña.',
  'aide.pont.echec': 'La extensión no pudo conectarse. Inténtalo de nuevo desde la extensión.',
  'aideR.intro': 'La extensión, y qué hacer cuando algo se atasca.',
  'aideR.ext.titre': 'La extensión',
  'aideR.ext.lead': 'Tu puntuación en cada oferta, LinkedIn incluido.',
  'aideR.ext.telephone': 'Se instala en el ordenador, en Chrome. Abre Radar en tu ordenador y luego “Ayuda y extensión”.',
  'aideR.ext.dejaInstallee': '¿Ya instalada? Conéctala',
  'aideR.ext.pasInstallee': '¿Todavía no instalada? Instálala',
  'aideR.ext.pasDeBouton': '¿No ves el botón “Conectar con Radar”? Usa un código:',
  'aideR.ext.connectee': 'Extensión conectada',
  'aideR.ext.nonConnectee': 'La extensión no está conectada',
  'aideR.ext.rienEnvoye': 'Todavía ninguna oferta enviada a través de ella.',
  'aideR.ext.dernierEnvoi': 'Último envío: {date}.',
  'aideR.ext.ailleurs': 'En LinkedIn e Indeed se activa sola. En otros sitios, muéstrale el sitio una vez:',
  'demo.pause': 'Pausa',
  'demo.lecture': 'Reproducir',
  'demo.reduit': 'Animación desactivada: “reducir el movimiento” está activado.',
  'demo.annuler': 'Cancelar',
  'demo.refuser': 'Rechazar',
  'demo.autoriser': 'Permitir',
  'demo.install.titre': 'Instalar y fijar',
  'demo.install.aria': 'Animación: en Chrome Web Store, hacer clic en “Añadir a Chrome”, confirmar, luego abrir la pieza de puzle y fijar la extensión. Su icono aparece en la barra.',
  'demo.install.e1': '“Añadir a Chrome”',
  'demo.install.e2': '“Añadir extensión”',
  'demo.install.e3': 'La pieza de puzle, luego la chincheta',
  'demo.install.slogan': 'Tu puntuación en cada oferta',
  'demo.install.dlgTitre': '¿Añadir “AI Job Fit”?',
  'demo.install.dlgTexte': 'Podrá leer las ofertas que abras.',
  'demo.install.menu': 'Extensiones',
  'demo.install.ajouter': 'Añadir extensión',
  'demo.ac.bouton': 'Activar en este sitio',
  'demo.ac.emp': 'Hospital Ejemplo · Valencia',
  'demo.co.titre': 'Conectar a Radar',
  'demo.co.aria': 'Animación: en las opciones de la extensión, hacer clic en “¿Tienes una cuenta de Radar?”, luego en “Conectar con Radar”, permitir. Radar confirma en una pestaña, y el CV llega a la extensión.',
  'demo.co.e1': '“¿Tienes una cuenta de Radar?”',
  'demo.co.e2': '“Conectar con Radar”, luego “Permitir”',
  'demo.co.e3': 'Radar confirma en una pestaña',
  'demo.co.e4': 'Tu CV está en la extensión',
  'demo.co.import': 'Importa tu CV para empezar',
  'demo.co.depot': 'Sube tu CV',
  'demo.co.lien': '¿Tienes una cuenta de Radar? Inicia sesión',
  'demo.co.compte': 'Tengo una cuenta de Radar',
  'demo.co.bouton': 'Conectar con Radar',
  'demo.co.ouBien': 'O bien: contraseña, o código de Radar',
  'demo.co.perm': '¿Permitir el acceso a Radar?',
  'demo.co.fermer': 'Puedes cerrar esta pestaña.',
  'demo.co.cv': 'Tu CV viene de Radar',
  'demo.co.nom': 'Tu nombre',
  'demo.co.metier': 'Tu profesión',
  'demo.co.bouton2': '“Guardar en Radar” aparece en cada oferta.',
  'demo.ac.titre': 'Activar en un sitio desconocido',
  'demo.ac.aria': 'Animación: en el anuncio de la web de un empleador, hacer clic en el icono de la extensión, luego en “Activar en este sitio”, permitir. La puntuación aparece en el anuncio.',
  'demo.ac.e1': 'El icono de la extensión',
  'demo.ac.e2': '“Activar en este sitio”',
  'demo.ac.e3': '“Permitir”, una vez por sitio',
  'demo.ac.e4': 'La puntuación aparece en el anuncio',
  'demo.ac.poste': 'Analista financiero (H/M/X)',
  'demo.ac.pasAcces': 'Todavía no activa en este sitio.',
  'demo.ac.perm': '¿Permitir en este sitio?',
  'demo.ac.profil': 'Buen perfil',
  'demo.ac.adapter': 'Adaptar mi CV',
  'demo.ac.enregistrer': 'Guardar en Radar',
  'demo.emp.titre': 'Un empleador que todavía no se sigue',
  'demo.emp.aria': 'Animación: solicitas la activación, un correo confirma enseguida, un segundo correo dice que el empleador está en línea, normalmente en menos de una semana.',
  'demo.emp.l1': 'Lo solicitas',
  'demo.emp.l1s': '“Solicitar la activación”',
  'demo.emp.l2': 'Un correo confirma',
  'demo.emp.l2s': 'enseguida',
  'demo.emp.l3': 'Está en línea',
  'demo.emp.l3s': 'normalmente en menos de una semana',
  'aideR.faq.titre': 'Cuando algo se atasca',
  'aideR.q.score': 'No hay puntuación en un anuncio',
  'aideR.r.score': 'En un sitio que no conoce, la extensión espera tu permiso. Una vez por sitio:',
  'aideR.r.scoreTel': 'En un sitio que no conoce, la extensión espera tu permiso: haz clic en su icono y luego en “Activar en este sitio”. Una vez por sitio.',
  'aideR.q.reconnait': 'La extensión ya no me reconoce',
  'aideR.r.reconnait': 'Ordenador nuevo, contraseña cambiada: vuelve a conectarla. En sus opciones, “Conectar con Radar”, o escribe este código:',
  'aideR.q.employeur': 'Un empleador no está en la lista',
  'aideR.r.employeur': 'Añade la dirección de su página de empleo en Empleadores. Si Radar todavía no sabe leerla, solicita la activación. No es una avería.',
  'aideR.cta.employeur': 'Ir a los empleadores',
  'aideR.q.mails': 'No recibo los correos',
  'aideR.r.mails': 'Mira primero en el correo no deseado. Una dirección de empresa a veces filtra Radar: prueba con una dirección personal.',
  'aideR.cta.adresse': 'Cambiar de dirección',
  'aideR.q.rythme': 'Demasiados correos, o muy pocos',
  'aideR.r.rythme': 'Cambia de ritmo. Cada uno dice cuántas ofertas te habría enviado.',
  'aideR.cta.rythme': 'Cambiar de ritmo',
  'aideR.q.pause': 'Me voy de vacaciones',
  'aideR.r.pause': 'Pon los correos en pausa una, dos o cuatro semanas. Se reanudan solos.',
  'aideR.cta.pause': 'Poner en pausa',
  'aideR.q.supprimer': 'Eliminar mi cuenta',
  'aideR.r.supprimer': 'Al final de los Ajustes. Tu CV y tus puntuaciones se borran. Antes puedes descargar tus datos.',
  'aideR.cta.compte': 'Abrir mi cuenta',
  'aideR.prive.titre': 'Lo que sigue siendo privado',
  'aideR.prive.texte': 'Tu CV, tus puntuaciones y tus candidaturas solo los ves tú. Los empleadores seguidos y sus ofertas son comunes a todas las cuentas.',
  'aideR.ecrire.titre': 'Escríbenos',
  'aideR.ecrire.texte': 'Un error, una idea, un sitio que añadir: el mensaje llega por correo, con tu dirección para la respuesta.',
  'manques.titre': 'Lo que piden tus ofertas y tu CV no dice',
  'manques.intro': 'Sobre las {n} ofertas de tus profesiones en los últimos 30 días. Si lo tienes, escríbelo: tus próximas puntuaciones lo tendrán en cuenta.',
  'manques.chez': 'pedido en {liste}',
  'manques.sitesAnnonces': 'sitios de anuncios',
  'manques.jeLai': 'Lo tengo',
  'manques.ajoute': '“{mot}” añadido a tu CV, en tus competencias.',
  'manques.annuler': 'Deshacer',
  'manques.retire': '“{mot}” quitado de tu CV.',
  'manques.nAria': 'Pedido por {n} ofertas',
  'adresse.actuelle': 'Radar te escribe a {email}.',
  'adresse.changer': 'Usar otra dirección',
  'adresse.placeholder': 'Tu dirección personal',
  'adresse.envoyer': 'Enviar el enlace de confirmación',
  'adresse.aide': '¿Una dirección del trabajo? Tus alertas de empleo se leerían en el servidor de tu empleador. Otra dirección se confirma con un enlace.',
  'adresse.attente': 'Pendiente de confirmación: {attente}.',
  'adresse.statut.lienLe': 'Enlace enviado: {quand}.',
  'adresse.statut.envoye': 'Brevo se ha hecho cargo, todavía sin noticias del servidor de destino.',
  'adresse.statut.livre': 'Aceptado por el servidor de esta dirección.',
  'adresse.statut.differe': 'Retrasado por el servidor de esta dirección, nuevo intento en curso.',
  'adresse.statut.refuse': 'Rechazado por el servidor de esta dirección: {raison}',
  'adresse.statut.pasParti': 'El enlace no ha salido: {erreur}',
  'adresse.statut.pasRecu': '¿No lo has recibido? Mira en el correo no deseado o en la cuarentena de tu buzón.',
  'adresse.renvoyer': 'Volver a enviar el enlace',
  'adresse.lienToast': 'Enlace enviado a {email}. Radar te escribirá allí en cuanto se abra.',
  'adresse.compteToast': 'Radar vuelve a escribirte a la dirección de tu cuenta.',
  'adresse.echecToast': 'El enlace no se pudo enviar. Inténtalo más tarde.',
  'adresse.confirmee': 'Dirección confirmada: a partir de ahora Radar te escribirá allí.',
  'adresse.lienInvalide': 'Este enlace de confirmación ya no es válido. Pide uno nuevo.',
  'parcours.aria': 'Tu candidatura, paso a paso',
  'parcours.cv': 'Tu CV para {employeur}',
  'parcours.cvSans': 'Tu CV adaptado',
  'parcours.cvPret': 'Listo. Míralo y modifícalo abajo.',
  'parcours.cvPretEstime': 'Listo. Puntuación estimada con este CV: {estime} en lugar de {score}.',
  'parcours.lettre': 'Tu carta (opcional)',
  'parcours.lettreRediger': 'Redactar la carta',
  'parcours.lettreNon': 'No la necesito',
  'parcours.postuler': 'Postularme en {employeur}',
  'parcours.postulerSans': 'Postularme desde el anuncio',
  'parcours.ouvrirPage': 'Abrir la página de candidatura',
  'parcours.dejaFait': 'Hecho',
  'parcours.envoye': '¿Enviada?',
  'parcours.envoyeOui': 'Sí, enviada',
  'parcours.envoyeNon': 'No la enviaré',
  'parcours.envoyeToast': 'Anotado: enviada.',
  'parcours.envoyeNonToast': 'Anotado: sale de tus ofertas.',
  'parcours.envoyeLe': 'Enviada el {date}. Si no hay noticias antes del {relance}, Radar te propondrá un seguimiento.',
  'suivi.lienPlaceholder': 'Pegar el enlace de un anuncio',
  'suivi.lienAria': 'Enlace de un anuncio',
  'suivi.lienAjouter': 'Añadir',
  'suivi.lienLecture': 'Leyendo la página…',
  'suivi.lienIllisible': '{raison} Pega su texto abajo.',
  'offre.lienLater': 'Elegiste “Más tarde” en el correo: confírmalo con un clic.',
  'offre.lienSkip': 'Elegiste “No es para mí” en el correo: confírmalo con un clic.',
  'raison.loin': 'Demasiado lejos',
  'raison.metier': 'No es mi profesión',
  'raison.salaire': 'Salario',
  'raison.employeur': 'No este empleador',
  'raison.autre': 'Otra',
  'raison.merci': 'Gracias, tomamos nota.',
  'suivi.rappelLe': 'recordatorio el lunes {date}',
  'emp.pourVousUn': '1 oferta para ti de {n} en tus profesiones, la mejor en {m}.',
  'emp.pourVousPlus': '{k} ofertas para ti de {n} en tus profesiones, la mejor en {m}.',
  'emp.uneSeule': '1 oferta en tus profesiones, en {m}: supera tu umbral.',
  'emp.sousSeuil': '{n} ofertas en tus profesiones, ninguna en {seuil} o más. La mejor: {m}.',
  'emp.sousSeuilUn': '1 oferta en tus profesiones, en {m}: por debajo de tu umbral de {seuil}.',
  'emp.prefixeAnnonces': 'Sitio de anuncios · {phrase}',
  'emp.retour': 'Empleadores',
  'emp.introuvable': 'Radar ya no sigue a este empleador.',
  'emp.suiviDepuis': 'seguido desde el {date}',
  'emp.dansMetiersTitre': 'En tus profesiones',
  'emp.etatCandidature': 'En tus candidaturas',
  'emp.autresUn': '1 oferta más en {nom}',
  'emp.autresPlus': '{n} ofertas más en {nom}',
  'emp.chercher': 'Buscar en estas ofertas',
  'emp.evaluer': 'Evaluar para mí',
  'emp.aucunResultat': 'Ninguna oferta coincide.',
  'emp.autresAide': 'Fuera de tus profesiones Radar no puntúa: las lista para que no se te escape nada. “Evaluar para mí” compara una oferta concreta con tu CV.',
  'emp.vide': 'Por ahora ninguna oferta en línea en este empleador.',
  'emp.illisibleNuits': 'Ilegible desde hace {n} noches. El equipo está avisado, no tienes que hacer nada.',
  'emp.illisibleNuit': 'Ilegible esta noche. El equipo está avisado, no tienes que hacer nada.',
  'emp.apprentissage': 'En aprendizaje: respuesta antes del {date}. No cuenta en tus {max}.',
  'emp.apprentissageDepuis': 'En aprendizaje desde el {date}. No cuenta en tus {max}.',
  'emp.apprendLire': 'Radar está aprendiendo a leer {hote}. Respuesta antes del {date}.',
  'emp.apprendLireDepuis': 'Radar está aprendiendo a leer {hote} desde el {date}.',
  'emp.refusee': 'Radar no sabe leer {hote}.',
  'emp.rangeesIci': 'Mientras tanto, tus ofertas de {nom} guardadas desde la extensión se reúnen aquí.',
  'emp.rangeesIciRefus': 'Tus ofertas de {nom} guardadas desde la extensión siguen reunidas aquí.',
  'emp.suivisTitre': 'Seguidos',
  'emp.enAttenteTitre': 'En aprendizaje · no cuentan en tus {max}',
  'emp.enAttenteTitreSansMax': 'En aprendizaje',
  'emp.annoncesTitre': 'Sitios de anuncios',
  'emp.annoncesAide': 'Cientos de empleadores: Radar solo se queda con tus profesiones y tus regiones.',
  'emp.suggeresTitre': 'Sugeridos para ti',
  'emp.suggereUn': '1 oferta en tus profesiones',
  'emp.suggerePlus': '{n} ofertas en tus profesiones',
  'emp.luQuand': 'Leído {quand}',
  'emp.sousTitre': 'Radar relee sus páginas cada noche · {n} de {max} sitios seguidos',
  'emp.sousTitreSansMax': 'Radar relee sus páginas cada noche · {n} sitios seguidos',
  'pont.texte': 'Has guardado {n} ofertas de {nom} desde la extensión. ¿Poner {nom} en tu radar?',
  'pont.suivre': 'Seguir a {nom}',
  'pont.ajouter': 'Añadir su página de empleo',
  'pont.non': 'No, gracias',
  'pont.nonToast': 'Radar ya no te lo propondrá.',
  'entretien.titre': 'Preparar la entrevista',
  'entretien.aide': 'Las preguntas probables, y lo que tu CV te permite responder.',
  'entretien.preparer': 'Preparar',
  'entretien.redaction': 'Preparando…',
  'entretien.refaire': 'Rehacer',
  'entretien.aPoser': 'Para preguntarles',
  'entretien.aideSourcee': 'Radar busca la actualidad del empleador y su forma de seleccionar, y luego prepara las preguntas probables. Cada fuente se cita. Alrededor de un minuto.',
  'entretien.enCours': 'Radar está buscando, alrededor de un minuto. Puedes salir de la página.',
  'entretien.erreur': 'La búsqueda no ha dado resultado.',
  'entretien.actualite': 'El empleador ahora mismo',
  'entretien.deroule': 'Cómo selecciona',
  'entretien.questions': 'Las preguntas probables',
  'entretien.tireeOffre': 'Sacada de la oferta:',
  'entretien.rapportee': 'Referida',
  'entretien.rienTrouve': 'No se ha encontrado nada público y reciente sobre el empleador.',
  'entretien.agence': 'La oferta no nombra al empleador. Si lo conoces, Radar buscará sobre él.',
  'entretien.employeurNom': 'Nombre del empleador',
  'entretien.avecEmployeur': 'Buscar sobre este empleador',
  'entretien.parcours': 'Candidatura enviada · Volver a ver el recorrido',
  'remu.titre': 'Remuneración',
  'remu.encore': 'Te quedan {n} este mes.',
  'remu.plusDEssai': 'No te quedan intentos este mes.',
  'remu.aVolonte': 'Sin límite con Complet.',
  'remu.avecComplet': 'Con Radar Complet.',
  'remu.comparer': 'Comparar',
  'remu.nonAnnonce': 'Salario sin indicar',
  'remu.estimer': 'Estimar',
  'remu.aide': 'Radar busca lo que indica la oferta, el mínimo del sector y referencias recientes, y cita cada fuente. Alrededor de un minuto.',
  'remu.lancer': 'Estimar el salario',
  'remu.enCours': 'Radar está buscando, alrededor de un minuto. Puedes salir de la página.',
  'remu.erreur': 'La búsqueda no ha dado resultado.',
  'remu.reessayer': 'Reintentar',
  'remu.offreDit': 'Lo que dice la oferta',
  'remu.offreMuette': 'La oferta no indica ningún importe.',
  'remu.minimum': 'El mínimo del sector',
  'remu.auMoins': '{qui}: al menos {montant}',
  'remu.sousEnPartie': 'La parte baja de la horquilla indicada está por debajo de este mínimo.',
  'remu.sousEntierement': 'El importe indicado está por debajo de este mínimo.',
  'remu.marche': 'Las referencias del mercado',
  'remu.fourchette': '{fourchette}, según {n} fuentes que coinciden.',
  'remu.pasDeFourchette': 'Las referencias no coinciden lo suficiente para una horquilla.',
  'remu.aucunRepere': 'No se ha encontrado ninguna referencia fiable.',
  'remu.unRepere': 'Una sola referencia fiable, sin horquilla.',
  'remu.quatreCinquiemes': 'Al 4/5: {fourchette}',
  'remu.avantages': 'Las ventajas',
  'remu.aDemander': 'Para preguntar',
  'remu.agence': 'La oferta no nombra al empleador: las referencias valen para la profesión.',
  'remu.source': 'Fuente: {qui}',
  'remu.sourceDatee': 'Fuente: {qui}, {date}',
  'remu.sourceOffre': 'la oferta',
  'remu.sources': 'Fuentes: {retenues}, {ecartees}',
  'remu.retenue1': '1 retenida',
  'remu.retenues': '{n} retenidas',
  'remu.ecartee1': '1 descartada',
  'remu.ecarteesN': '{n} descartadas',
  'remu.ecartees': 'Descartadas',
  'remu.estimeLe': 'Estimado el {date}.',
  'remu.refaire': 'Rehacer',
  'remu.environ': 'Unos {montant}',
  'remu.entre': 'de {a} a {b}',
  'remu.parHeure': 'brutos por hora',
  'remu.parMois': 'brutos al mes',
  'remu.parAn': 'brutos al año',
  'remu.raison.page_fermee': 'página cerrada o retirada',
  'remu.raison.page_illisible': 'página ilegible',
  'remu.raison.introuvable': 'cita no encontrada en la página',
  'remu.raison.trop_ancienne': 'más de 18 meses',
  'remu.raison.domaine_ecarte': 'agregador o copia',
  'remu.raison.sans_extrait': 'sin cita',
  'remu.raison.sans_source': 'sin dirección',
  'remu.raison.chiffre_absent': 'cifra ausente de la cita',
  'remu.raison.autre_pays': 'otro país u otra moneda',
  'remu.cadre': 'País del puesto: {pays}. Importes en bruto anual.',
  'remu.fiabiliteTitre': 'El empleador',
  'remu.fiabilite': '{type}. Fiabilidad de las cifras públicas: {fiab}.',
  'remu.soit': '(es decir, {montant})',
  'remu.comp.base': 'Base',
  'remu.comp.variable': 'Variable',
  'remu.comp.avantage': 'Ventaja',
  'remu.fiab.haute': 'alta',
  'remu.fiab.moyenne': 'media',
  'remu.fiab.basse': 'baja',
  'remu.fiab.inconnue': 'desconocida',
  'remu.type.grand_groupe_tech': 'Gran grupo tecnológico',
  'remu.type.startup_croissance': 'Start-up en crecimiento',
  'remu.type.startup_debut': 'Start-up joven',
  'remu.type.entreprise_traditionnelle': 'Empresa consolidada',
  'remu.type.conseil_ou_agence': 'Consultoría o agencia',
  'remu.type.pme_locale': 'Pyme local',
  'remu.type.commission': 'Remuneración a comisión',
  'remu.type.recrutement_tiers': 'Oferta publicada por un reclutador',
  'remu.type.public': 'Sector público o asociativo',
  'remu.type.inconnu': 'Tipo de empleador desconocido',
  'relance.titre': '¿Una semana sin noticias?',
  'relance.aide': 'Enviada el {date}. Radar solo propone un seguimiento por candidatura.',
  'relance.preparer': 'Preparar mi seguimiento',
  'relance.redaction': 'Redactando…',
  'relance.objet': 'Asunto: {sujet}',
  'relance.copier': 'Copiar',
  'relance.copie': 'Seguimiento copiado.',
  'relance.envoyee': 'Lo he enviado',
  'relance.reecrire': 'Reescribir',
  'relance.reponse': 'He recibido una respuesta',
  'relance.reponseQuestion': '¿Qué respuesta?',
  'relance.entretien': 'Una entrevista',
  'relance.refus': 'Un rechazo',
  'relance.abandon': 'Lo dejo',
  'relance.abandonQuestion': '¿Dejar esta candidatura? Sale de Mis ofertas.',
  'relance.abandonOui': 'Sí, dejarla',
  'relance.abandonToast': 'Candidatura quitada de Mis ofertas.',
}
